import { ITrafficSource } from '@clickster/constant-definitions/dist-esm/entities/traffic-source/types';
import { fetchAllPaginated } from '@/src/services/utils/fetch-all-paginated';
import { API_V2 } from '@/src/lib/axios';

const TRAFFIC_SOURCE_ENDPOINT = '/traffic-sources';

/**
 * Fetches all traffic sources for use in the Spotlight search component.
 * Results are filtered client-side since traffic sources are a small dataset.
 * @returns {Promise<ITrafficSource[]>} All available traffic sources.
 */
export const fetchSpotlightTrafficSources = async (): Promise<ITrafficSource[]> => {
  return fetchAllPaginated<ITrafficSource>(API_V2, TRAFFIC_SOURCE_ENDPOINT, {});
};

/**
 * Filters a list of traffic sources by a search query against name, nickname, and shortname.
 * @param {ITrafficSource[]} sources - The full list of traffic sources.
 * @param {string} query - The search query string.
 * @returns {ITrafficSource[]} The filtered list of traffic sources.
 */
export const filterTrafficSources = (sources: ITrafficSource[], query: string): ITrafficSource[] => {
  if (!query || !sources.length) return sources;
  const lower = query.toLowerCase();

  return sources.filter(
    (source) =>
      source?.name?.toLowerCase().includes(lower) ||
      source?.nickname?.toLowerCase().includes(lower) ||
      source?.shortname?.toLowerCase().includes(lower),
  );
};
